module.exports = {
  INSURANCE: 'insurance',
  MILEAGE: 'mileage',
  EQUIPMENT: 'equipment',
  INVENTORY: 'inventory',
  FEE: 'fee',
  OTHER: 'other',
};
